import logo from './logo.svg';
import './App.css';
import Grid from './components/grid/grid';


function App() {
  return (
    <div className="App">
 
      <div>
          <Grid />
        </div>
    </div>
  );
}

export default App;
